export default __webpack_public_path__ + "static/media/mobile3.05ccb2f3.png";